var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

subscribe("cart-update", (data) => {
  insuranceCalc();
});

if(window.location.pathname == "/cart"){
    insuranceCalc();
}

function insuranceSet(){
  var attributes = {};
  if(!document.querySelector('[name="attributes[insurance]"]').checked){
                //customer has declined insurance
                attributes = {
                    "insurance": "false",
                    "decline-insurance": "declined"
                    }
            }
  else{
    //customer has accepted insurance
                attributes = {
                    "insurance": "true",
                    "decline-insurance": "not-declined"
                    }
  }
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ attributes: attributes })
                    })
                    .then(response => {
                      this.insuranceCalc();
                    })
                    .catch((error) => {
                    console.error('Error:', error);
                    });
}
function insuranceCalc(){
  fetch(window.Shopify.routes.root + 'products/package-protection.js')
  .then(response => response.json())
  .then(insurProduct => {
        var reCalc = false;
        var insurVar = 0;
        var reqVar = 0;
        var reqPrice = 0;
        var insurTotal = 0;
        var exemptInCart = 0;
        var aItem;

        fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cart => {
            for(aItem of cart.items){
                if(aItem.handle == "package-protection"){
                    insurTotal = aItem.original_line_price;
                    insurVar = aItem.variant_id;
                    reqVar = aItem.variant_id;
                    reqPrice = aItem.original_price;
                }
                else if(aItem.gift_card){
                    exemptInCart = exemptInCart + aItem.original_line_price;
                }
            }
            var calcTotal = Math.round((cart.total_price - exemptInCart - insurTotal));
            var attributes = {};
            var updates = {};

            if(calcTotal == 0){
                //no cart contents require insurance, hide the div entirely
                attributes = {
                    "insurance": "false",
                    "decline-insurance": "not-declined"
                    }
            }
            else if(calcTotal < 50000){
                reqVar = 51321369821499;
                reqPrice = 299;
            }
            else if(calcTotal < 100000){
                reqVar = 51321369854267;
                reqPrice = 499;
            }
            else{
                reqVar = 51321371459899;
                reqPrice = 699;
            }
                        if(insurVar != reqVar){
                            reCalc = true;
                        }

            document.getElementById("reqPrice").innerHTML = Shopify.formatMoney(reqPrice, window.Shopify.money_format);

            let pChecked = false;
            try{
             pChecked = document.querySelector('[name="attributes[insurance]"]').checked
            }
            catch(error){
                calcTotal = 0;
            }
            if(!pChecked){
                //customer has declined insurance
                calcTotal = 0;
            }
            if(calcTotal == 0 && insurTotal > 0){
                //then there is insurance in the cart that shouldn't be, remove it
                updates = {};
                updates[insurVar] = 0;
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ updates: updates, attributes: attributes })
                    })
                    .then(response => {
                    document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
                    })
                    .catch((error) => {
                    console.error('Error:', error);
                    });
            }
            else if(calcTotal > 0)
            {
                //then the cart is eligible for insurance, check to see if right amount is applied
                if(reCalc){
                    //then current insurance amount in cart is not correct
                    updates = {};
                    updates[reqVar] = 1;
                    
                    if(insurVar != 0)
                    {
                        //insurance is currently in the cart, but not the correct amount, remove old
                        updates[insurVar] = 0;
                    }
                    fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                                'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ updates: updates, attributes: attributes  })
                    })
                    .then(response => {
                        document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
                }
            }
        })
    });
}
